<template>
  <NoProviderReference v-if="isAuthenticated" :error-title="t('payment-failed-message')" error-details="" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import NoProviderReference from "@/components/providers/NoProviderReference.vue";
import authHelper from "@/helpers/authHelper";

export default defineComponent({
  name: "PaymentFailedView",
  components: { NoProviderReference },
  setup() {
    const { t } = useI18n();
    // Gate on either auth flow: the old `/device/` login sets `session_data`,
    // while SuperPacman (GCash / Maya) only sets `device_tag`. Both persist in
    // localStorage across the Xendit redirect back to this same-origin page.
    const isAuthenticated = authHelper.getAuthenticatedDeviceTag() !== null;

    return {
      t,
      isAuthenticated,
    };
  },
  beforeMount() {
    if (!this.isAuthenticated) {
      window.open("https://payjoy.com", "_self");
    }
  },
});
</script>
